import SystemStatePage from './SystemStatePage';
function NotFoundPage() { return <SystemStatePage code="404" description="The page may have moved or the address may be incorrect." title="Page not found" />; }

export default NotFoundPage;
